<template lang="pug">
.headline
  .lp-container
    PlanetSvg.headline__decoration
    .headline__text.lp-headline-text
      span.lp-headline-subtitle {{ $t('pages.ssr_pricing_plans.headline.subtitle') }}
      h1.lp-headline-title {{ $t('pages.ssr_pricing_plans.headline.title') }}
      p.lp-headline-description(
        v-html="$t('pages.ssr_pricing_plans.headline.description')"
      )
</template>

<script>
import PlanetSvg from './svg/Planet'

export default {
  components: {
    PlanetSvg
  }
}
</script>

<style lang="scss" scoped>
.headline {
  z-index: 5;
  position: relative;
  margin-bottom: 80px;
  overflow-x: clip;

  &__text {
    z-index: 5;
    position: relative;
    padding-left: 36px;
    padding-right: 36px;
    width: 100%;

    @media (min-width: 1562px) {
      width: 720px;
    }

    @include display-less(tablet) {
      padding-left: $gap;
      padding-right: $gap;
    }
  }

  &__decoration {
    left: 50%;
    z-index: 3;
    bottom: -204px;
    margin-left: 220px;
    position: absolute;
  }
}
</style>
